module.exports = __webpack_public_path__ + "img/filedrop-active.bbfb0e2d.svg";